/**
 * Filters an object by removing properties that are included in the ignore list.
 *
 * @param {object} originalObject - The original object to be filtered.
 * @param {string[]} ignoreList - An array of property names to be ignored (removed from the original object).
 * @returns {object} A new object that contains the properties of the original object, excluding the properties specified in list
 */
export const filterObject = (originalObject: { [key: string]: unknown }, ignoreList: string[]) =>
    Object.keys(originalObject)
        .filter((key) => !ignoreList.includes(key))
        .reduce(
            (obj, key) => ({
                ...obj,
                [key]: originalObject[key]
            }),
            {}
        );
